import dayjs from "dayjs";

// Expected string pattern: MM/DD/YYYY
export function isValidDob(string: string) {
  const dob = new Date(string);
  return !isNaN(dob.getTime());
}

export function getAge(dob: string) {
  const parsedDob = dayjs(dob);
  return dayjs().diff(parsedDob, 'years');
}

// dob is in the format of YYYY-MM-DD
export function formatDob(dob: string) {
  // Split the date into an array of [year, month, day]
  const date = dob.split('-');
  // Return the date in the format of MM/DD/YYYY
  return `${date[1]}/${date[2]}/${date[0]}`;
}

export function formatDobForBackend(dob: string) {
  // Split the date into an array of [month, day, year]
  const date = dob.split('/');
  // Return the date in the format of YYYY-MM-DD
  return `${date[2]}-${date[0]}-${date[1]}`;
}